import { Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { v4 as uuid} from 'uuid'
import moment from 'moment';
// services
import { MilesAndMore } from '../../../services/miles-n-more.service';
import { DataStorageService } from '../../../../shared/services/data-storage.service';
import { ErrorHandler } from '../../../../shared/services/error-handler.service';
import { BookingService } from '../../../services/booking.service';
import { PriceService } from '../../../services/price.service';
// models
import { AppState } from "../../../models/app-state.interface";
import { PayByMilesRequest } from '../../../models/miles-and-more';
// globals
import { MILES_LOGIN_URL } from '../../../../shared/globals';
import { updateMilesPaymentStatus, updateSelectedMiles } from 'app/booking/reducers/milesAndMore.reducer';

let maxUseable = 1000;
@Component({
  selector: 'app-miles-and-more-pay',
  standalone: true,
  templateUrl: './miles-and-more-pay.component.html',
  styleUrls: ['./miles-and-more-pay.component.scss']
})
export class MilesAndMorePayComponent implements OnInit, OnDestroy {
  private _milesSubscription: Subscription;
  private _milesFormSubscription: Subscription;
  private _bookingInitSubscription: Subscription;
  private _priceSubscription: Subscription;
  private _milesRedeemSubscription$: Subscription;

  @Input('appCopy') appCopy: any;
  @Input('selectedLanguage') selectedLanguage: any;
  public milesRedeemLoadingStatus = 'idle';
  public milesRedeemed: boolean = false;
  public dataLoaded = false;
  public callbackURL = location.href.split('?')[0];
  public price;
  public canSpendMiles = true;
  public milesLoginUrl = MILES_LOGIN_URL;
  public isPriceAdjusted = false;
  public isD2dService = false;
  public milesVerifiedStatus = '';
  public priceWhenRedeemed = 0;
  public bookingType
  public transactionStatus = {
    CREATED: 0,
    AUTHORISED: 1,
    REJECTED: 2
  }
  public bookingRemainingPrice = {
    price: 0,
    currency: '',
    viewPrice: ''
  }

  public milesAndMoreForm: FormGroup;
  public autoTicks = false;
  public showTicks = false;
  public disabled = false;
  public max = 100;
  public min = 1;
  public step = 1;
  public value = 15;
  public milesBalance = 1;
  public preFilledWidth = '10%';

  constructor(
    private _appStore: Store<AppState>,
    private _milesAndMoreService: MilesAndMore,
    private _dataStorageService: DataStorageService,
    private _activatedRoute: ActivatedRoute,
    private _errorService: ErrorHandler,
    private _bookingService: BookingService,
    private _priceService: PriceService,
    private _zone: NgZone,
    private _router: Router
  ) {
  }

  ngOnInit(): void {
    const state = this.getState(this._appStore);
    const miles: any = state.milesAndMoreReducer.miles;
    this.min = miles.minimumMiles;
    this.max = miles.maximumMiles;
    this.milesBalance = miles.milesBalance;
    this.value = miles.minimumMiles;
    this.preFilledWidth = ((this.min / this.max) * 100) + '%';
    maxUseable = miles.maximumMiles;
    const booking = state.bookingReducer.bookingDetails;
    this.isD2dService = booking.isD2dService;
    this.bookingType = booking.bookingType;
    if (booking.isD2dService && state.milesAndMoreReducer.payByMilesResponse?.totalMilesSubmitted) {
      this.value = state.milesAndMoreReducer.payByMilesResponse?.totalMilesSubmitted;
    } else if (booking.bookingProduct === 'abc' && state.milesAndMoreReducer.payByMilesResponse?.abcMilesSubmitted) {
      this.value = state.milesAndMoreReducer.payByMilesResponse?.abcMilesSubmitted;
    } else if (booking.bookingProduct === 'ccd' && state.milesAndMoreReducer.payByMilesResponse?.ccdMilesSubmitted) {
      this.value = state.milesAndMoreReducer.payByMilesResponse?.ccdMilesSubmitted;
    }
    this.milesAndMoreForm = new FormGroup({
      sliderValue: new FormControl(this.value, [Validators.min(this.min), Validators.max(this.max)]),
      sliderValueInp: new FormControl(this.value)
    });

    this._milesFormSubscription = this.milesAndMoreForm.valueChanges.subscribe(data => {
      this._appStore.dispatch(updateSelectedMiles({ payload: data.sliderValue }));
      this.getRamaingPrice();
    });

    let timer;
    this._milesSubscription = this._appStore.select('milesAndMoreReducer')
      .subscribe(res => {
        this.milesRedeemed = res.milesRedeemed;
        this.milesBalance = res.miles?.milesBalance;
        this.milesVerifiedStatus = res.milesVerified?.status;
        this.priceWhenRedeemed = res.priceWhenRedeemed;
        if (res.errorType !== 'low_price' && this.max !== res.miles.maximumMiles && !res.milesRedeemed) {
          this.max = res.miles.maximumMiles;
          this.min = res.miles.minimumMiles;
          this.value = this.min;
          this.preFilledWidth = ((this.min / this.max) * 100) + '%';
          this.milesAndMoreForm.controls['sliderValue'].setValue(this.min);
          this.milesAndMoreForm.controls['sliderValue'].setValidators([
            Validators.min(this.min),
            Validators.max(this.max)
          ]);
          this.milesAndMoreForm.controls['sliderValue'].updateValueAndValidity();
        }

        if (timer) {clearTimeout(timer);}
        timer = setTimeout(() => {
          this.authorizMileTransection(res);
        }, 1000);
      });

    const qParams = this._activatedRoute.snapshot.queryParams;
    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: any) => {
        if (res.currentBookingLoaded && res.userLoaded && res.priceLoaded && !this.dataLoaded && qParams['status'] && qParams['id']) {
          this.dataLoaded = true;
          if (qParams['status'] && qParams['id']) {
            const qParams = this._activatedRoute.snapshot.queryParams;
            this._appStore.dispatch(updateMilesPaymentStatus({ payload: { id: qParams['id'], status: qParams['status'] } }));
            setTimeout(() => {
              this.updateMCcheckoutStatus();
            }, 100);
          }
          // this._dataStorageService.saveData();
        }
      });

    this._priceSubscription = this._appStore.select('priceReducer')
      .subscribe((price: any) => {
        this.price = price.price;
        this._zone.run(() => {
          let totalBookingPrice = this.price.pricingResponse[0].pricingBreakdown.totalPriceMajor;
          if (state.bookingReducer.bookingDetails.isD2dService) {
            totalBookingPrice += state.bookingReducer.bookingDetails.bookingProduct === 'abc'
              ? state.d2dReducer.inboundBooking.priceReducer.price.pricingResponse[0].pricingBreakdown.totalPriceMajor
                : state.d2dReducer.outboundBooking.priceReducer.price.pricingResponse[0].pricingBreakdown.totalPriceMajor
          }
          this.isPriceAdjusted = this.priceWhenRedeemed !== totalBookingPrice && this.milesVerifiedStatus === 'AUTHORISED';
          this.getRamaingPrice();
        });
      });

    this._milesRedeemSubscription$ = this._milesAndMoreService.milesCheckoutStatus$
      .subscribe((status => {
        this.milesRedeemLoadingStatus = status;
      }));

  }

  handleMilesChange(el) {
    this.milesAndMoreForm.setValue({
      sliderValue: +el.value,
      sliderValueInp: el.value,
    });
    this.milesAndMoreForm.updateValueAndValidity();
  }

  formatLabel(value: number) {
    if (value > 1000) {
      return Math.floor(value / 1000) + 'k';
    }
    return value
  }

  authorizMileTransection(res) {
    if (
      res.payByMilesResponse?.checkoutUrl &&
      localStorage.getItem('checkoutUrlCalled') === '0'
    ) {


      this._dataStorageService
        .saveDataPromise()
        .then((data) => {
          if (data) {
            localStorage.setItem('checkoutUrlCalled', '1');
          }
          const anchorTag = document.createElement('a');
          anchorTag.setAttribute('href', res.payByMilesResponse.checkoutUrl);
          anchorTag.hidden = true;
          document.body.appendChild(anchorTag);
          anchorTag.click();
        });
    }
  }

  updateMCcheckoutStatus() {
    const qParams = this._activatedRoute.snapshot.queryParams;
    this.milesVerifiedStatus = qParams['status'];
    this._router.navigate([], { replaceUrl: true, queryParams: {}, relativeTo: this._activatedRoute });
    this._priceService.getPricePromise()
      .then(async (price: any) => {
        const state = this.getState(this._appStore);
        let milesDiscount = 0;
        if (price.pricingResponse && price.pricingResponse[0]) {
          milesDiscount = price.pricingResponse[0].pricingBreakdown.milesDiscountMinor
        }
        const request = {
          bookingReference: state.bookingReducer.bookingDetails.bookingReference,
          transactionId: state.milesAndMoreReducer.payByMilesResponse.transactionId,
          transactionStatus: this.transactionStatus[qParams['status']],
          milesDiscount: milesDiscount
        };
        await this._milesAndMoreService.amendMcheckoutStatusPromise(request);
        this._priceService.getPrice();
      })
  }

  getRamaingPrice() {
    const state = this.getState(this._appStore);
    const { totalD2dPrice } = this._bookingService.getD2dDiscountPrice(state.priceReducer.price, true);
    const isD2dService = state.bookingReducer.bookingDetails.isD2dService;
    let totalPrice = state.priceReducer.price.pricingResponse[0].pricingBreakdown.totalPriceMajor;
    const currencySymbol = state.priceReducer.price.totalPrice.currencySymbol
    const miles = state.milesAndMoreReducer;
    if (state.priceReducer.price.promoCodesApplied) {
      totalPrice = totalPrice - (state.priceReducer.price.pricingResponse[0].pricingBreakdown.totalPriceMajor - state.priceReducer.price.pricingResponse[0].pricingBreakdown.discountedTotalPriceMajor);
    }

    if (isD2dService) {
      totalPrice = totalD2dPrice;
    }

    const usedMiles = this.milesAndMoreForm.controls['sliderValue'].value;
    const currencyRatio = state.milesAndMoreReducer.miles.currencyRatio;
    const calcultaedAmount = usedMiles / currencyRatio;
    if (!state.milesAndMoreReducer.milesRedeemed) {
      this.canSpendMiles = miles.miles.milesBalance > miles.miles.minimumMiles && miles.miles.maximumMiles >= miles.miles.minimumMiles;
      if (this.min <= usedMiles) {
        totalPrice = (totalPrice - calcultaedAmount).toFixed(2);
      }
    }
    if (!isD2dService && state.milesAndMoreReducer.milesRedeemed) {
      totalPrice = state.priceReducer.price.totalPrice.majorAmount;
    }

    if (this.bookingType === 'amend') {
      totalPrice = (state.priceReducer.price.priceHistory.majorAmount - calcultaedAmount).toFixed(2);
    }

    if (this.bookingType === 'amend' && state.milesAndMoreReducer.milesRedeemed) {
      totalPrice = state.priceReducer.price.priceHistory.majorAmount;
    }

    this.bookingRemainingPrice.price = +totalPrice;
    this.bookingRemainingPrice.currency = currencySymbol;
    this.bookingRemainingPrice.viewPrice = currencySymbol + +totalPrice;
  }

  redeemMiles() {
    const state = this.getState(this._appStore);
    const bookingReference = state.bookingReducer.bookingDetails.bookingReference;
    const serviceCardNumber = state.milesAndMoreReducer.miles.serviceCardNumber;
    const currencyRatio = state.milesAndMoreReducer.miles.currencyRatio;
    const milesSelected = state.milesAndMoreReducer.selectedMiles;
    const currency = state.priceReducer.price.totalPrice.currencyCode;
    const userId = uuid();
    const redirectUrl = this.callbackURL;
    const isD2dService = state.bookingReducer.bookingDetails.isD2dService;
    let request: PayByMilesRequest = {
      bookingReference,
      serviceCardNumber,
      currencyRatio,
      milesSelected,
      currency,
      redirectUrl,
      userId,
      bookingPrice: state.priceReducer.price.totalPrice.minorAmount
    };

    if (isD2dService) {
      const {inboundPrice, outboundPrice } = this._bookingService.getD2dDiscountPrice(state.priceReducer.price);
      let upsellBookingReference;
      let upsellBookingPrice;
      if (state.bookingReducer.bookingDetails.bookingProduct === 'abc') {
        const upsellBooking = state.d2dReducer.inboundBooking;
        upsellBookingReference = upsellBooking.bookingReducer.bookingDetails.bookingReference;
        upsellBookingPrice = inboundPrice * 100;
      } else {
        const upsellBooking = state.d2dReducer.outboundBooking;
        upsellBookingReference = upsellBooking.bookingReducer.bookingDetails.bookingReference;
        upsellBookingPrice = outboundPrice * 100;
      }
      request.upsellBookingReference = upsellBookingReference;
      request.upsellBookingPrice = upsellBookingPrice;
    }
    this._milesAndMoreService.payWithMiles(request);
  }

  formattedNumString(copyKey: string, num: number): string {
    const formattedNumber = new Intl.NumberFormat().format(num);
    return this.appCopy.panelHeader[copyKey + this.selectedLanguage] + `<b>${formattedNumber}</b>`;
  }

  formattedString_date(key: string) {
    const startDate = moment('2024-07-01');
    const endDate = moment('2024-08-31');
    const selectdTimeslotDate = this.getState(this._appStore).timeslotReducer.selectedDate;
    const currentDate = moment(selectdTimeslotDate).set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    });
    let mileRewardAmount = 1;
    if (currentDate.isBetween(startDate, endDate, undefined, '[]')) {
      mileRewardAmount = 5;
    }
    return this.appCopy.panelHeader[key + this.selectedLanguage].replace('%s', mileRewardAmount);
  }

  milesLoginRedirect() {
    this._milesAndMoreService.milesLoginRedirect(this.milesLoginUrl, this.callbackURL);
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy(): void {
    if (this._milesSubscription) { this._milesSubscription.unsubscribe(); }
    if (this._milesFormSubscription) { this._milesFormSubscription.unsubscribe(); }
    if (this._bookingInitSubscription) { this._bookingInitSubscription.unsubscribe(); }
    if (this._priceSubscription) { this._priceSubscription.unsubscribe(); }
    if (this._milesRedeemSubscription$) { this._milesRedeemSubscription$.unsubscribe(); }
  }
}
